import { FC, ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@new/lib';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  label: string;
  size?: 'sm' | 'md';
}

const sizeClasses = {
  sm: 'p-1',
  md: 'p-2',
} as const;

export const IconButton: FC<IconButtonProps> = ({
  icon,
  label,
  size = 'md',
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={cn(
        'rounded-full! text-(--neutral-black-NB600) hover:bg-(--neutral-white-NW800) transition-colors cursor-pointer',
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {icon}
    </button>
  );
};
